import { put, takeLatest, call } from "redux-saga/effects";
import { createActionOf } from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import * as Api from "../../../appApi/AppApi";

const TAG = "CountryCodeAndName";

function* workerCountryCodeAndName() {
  try {
    const response = yield call(
      Api.makeSecuredGetRequest,
      API_ENDPOINT.COUNTRY_CODE_AND_NAME
    );
    yield put(createActionOf(memberType.COUNTRY_CODE_AND_NAME_SUCCESS, 1, response));
  } catch (error) {
    console.error(TAG, "Worker get All Users failed: " + error.message);
    yield put(createActionOf(memberType.COUNTRY_CODE_AND_NAME_FAILED, 2, error));
  }
}

export const watchCountryCodeAndName = takeLatest(
  memberType.COUNTRY_CODE_AND_NAME_REQUESTED,
  workerCountryCodeAndName
);
